var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { gql } from '@apollo/client';
import { useDropShiftMutation } from '@amzn/atoz-shiftapp-types';
import { useLocation } from '../../hooks';
import { ShiftFlowModalContentTypes } from '../../features/ShiftFlowModal/ShiftFlowModalTypes';
import { AcceptVtoActions } from '../../context/AcceptVtoContext/AcceptVtoContextTypes';
import { useAcceptVtoSuccessData } from '../../features/ShiftFlowModal/AcceptVtoModalSuccess';
import { useAcceptVtoContext } from '../../context';
import { getOpportunitiesRefetchQuery, getScheduleRefetchQuery } from '../../utils/refetchQueries';
import { useAssociateContext } from '@amzn/atoz-shiftapp-utilities';
export var useAcceptVto = function (_a) {
    var vtoOpportunity = _a.vtoOpportunity, setModalContent = _a.setModalContent, setModalError = _a.setModalError;
    var _b = useAcceptVtoContext(), dispatch = _b[1];
    var pathname = useLocation().pathname;
    var _c = useAssociateContext(), associateInfo = _c.associateInfo, features = _c.features;
    var _d = useDropShiftMutation({
        variables: {
            shiftOpportunityId: { shiftOpportunityId: vtoOpportunity.id }
        },
        update: function (cache) {
            var scheduleIdentifier = cache.identify({
                __typename: 'Schedule'
            });
            cache.evict({ id: scheduleIdentifier });
            var shiftOpportunitiesIdentifier = cache.identify({
                __typename: 'ShiftOpportunities'
            });
            cache.evict({ id: shiftOpportunitiesIdentifier });
            cache.gc();
        },
        refetchQueries: __spreadArray(__spreadArray([], getScheduleRefetchQuery(pathname), true), getOpportunitiesRefetchQuery(pathname, features.findShiftsAPICallRedesign), true),
        awaitRefetchQueries: true,
        onCompleted: function () {
            setModalContent(ShiftFlowModalContentTypes.vtoSuccess);
        },
        onError: function (error) {
            setModalContent(ShiftFlowModalContentTypes.vtoError);
            setModalError(error);
        }
    }), onAcceptVto = _d[0], _e = _d[1], data = _e.data, error = _e.error, loading = _e.loading;
    return {
        useAcceptVtoState: {
            data: data,
            loading: loading,
            error: error
        },
        openVtoConfirmation: function () {
            dispatch({
                type: AcceptVtoActions.SetSelectedVto,
                payload: {
                    vto: vtoOpportunity
                }
            });
            setModalContent(ShiftFlowModalContentTypes.vtoAccept);
        },
        acceptVtoMutation: function () {
            var props = [];
            for (var _i = 0; _i < arguments.length; _i++) {
                props[_i] = arguments[_i];
            }
            dispatch({
                type: AcceptVtoActions.SetSelectedVto,
                payload: {
                    vto: vtoOpportunity
                }
            });
            onAcceptVto.apply(void 0, props);
        }
    };
};
export var DROP_SHIFT_MUTATION = gql(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    mutation DropShift($shiftOpportunityId: DropShiftInput!) {\n        dropShift(input: $shiftOpportunityId)\n    }\n"], ["\n    mutation DropShift($shiftOpportunityId: DropShiftInput!) {\n        dropShift(input: $shiftOpportunityId)\n    }\n"])));
useAcceptVto.fragments = {
    shiftOpportunity: gql(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n        fragment useAcceptVto_ShiftOpportunity on ShiftOpportunity {\n            id\n            ...UseAcceptVtoSuccessData_ShiftOpportunity\n        }\n\n        ", "\n    "], ["\n        fragment useAcceptVto_ShiftOpportunity on ShiftOpportunity {\n            id\n            ...UseAcceptVtoSuccessData_ShiftOpportunity\n        }\n\n        ", "\n    "])), useAcceptVtoSuccessData.fragments.shiftOpportunity)
};
var templateObject_1, templateObject_2;
